// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"747291d8","455":"d11e79d8","488":"05ee67b9","977":"781bf994"}[chunkId] + ".chunk.js";
};